export enum ESiteType {
    Test = 1,
    Validation = 2,
    Supervision = 3,
    PreparatoryWork = 4
}